import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const DeleteConfirmModal = ({ isOpen, onClose, owner, onConfirm }) => {
    const { isDark } = useTheme();

    if (!isOpen || !owner) return null;

    const styles = {
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '1rem',
        },
        modal: {
            background: isDark ? '#1e1e1e' : '#ffffff',
            borderRadius: '1rem',
            maxWidth: '400px',
            width: '100%',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
        },
        header: {
            padding: '1.5rem',
            borderBottom: `1px solid ${isDark ? '#333' : '#e5e7eb'}`,
        },
        title: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: isDark ? '#ffffff' : '#1f2937',
            marginBottom: '0.5rem',
        },
        body: {
            padding: '1.5rem',
            color: isDark ? '#d1d5db' : '#374151',
        },
        ownerName: {
            fontWeight: 600,
            color: isDark ? '#ffffff' : '#1f2937',
        },
        footer: {
            padding: '1.5rem',
            borderTop: `1px solid ${isDark ? '#333' : '#e5e7eb'}`,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.75rem',
        },
        button: {
            padding: '0.75rem 1.5rem',
            borderRadius: '0.5rem',
            border: 'none',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: 600,
            transition: '0.2s',
        },
        cancelButton: {
            background: isDark ? '#374151' : '#e5e7eb',
            color: isDark ? '#d1d5db' : '#374151',
        },
        deleteButton: {
            background: isDark ? '#dc2626' : '#ef4444',
            color: 'white',
        },
    };

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div style={styles.header}>
                    <h3 style={styles.title}>Delete Owner</h3>
                </div>

                <div style={styles.body}>
                    <p>
                        Are you sure you want to delete{' '}
                        <span style={styles.ownerName}>{owner.full_name}</span>?
                    </p>
                    <p style={{ marginTop: '0.5rem', fontSize: '0.875rem' }}>
                        This action cannot be undone.
                    </p>
                </div>

                <div style={styles.footer}>
                    <button
                        onClick={onClose}
                        style={{ ...styles.button, ...styles.cancelButton }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => onConfirm(owner.id)}
                        style={{ ...styles.button, ...styles.deleteButton }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
